import React, { memo } from "react";
import classNames from "classnames";
import classes from "./Body.scss";

const Body = props => {
  const { bodyClass, children } = props;

  const containerClass = classNames(classes.container, bodyClass);

  return <div className={containerClass}>{children}</div>;
};

export default memo(Body);
